import styled from 'styled-components';

import {Button2} from '../../styles/components/button.style';
import {media} from '../../styles/components/media-queries';
import {isIE11} from '../../helpers/ie.helper';

export const Title = styled.h3`
  font-size: 2.4rem;
  margin: 0;
  padding-top: ${props => props.theme.basketModal.padding};
  padding-right: ${props => props.theme.basketModal.padding};
  padding-left: ${props => props.theme.basketModal.padding};
  padding-bottom: ${props => props.theme.padding};
  ${media.small`
    font-size: 2rem;
    padding: 0.6rem;
  `};
`;

export const HeaderTile = styled(Title)`
  background-color: ${p => p.theme.primaryColor};
  width: 100%;
  padding-top: 0;
  ${media.small`
    padding: ${props => props.theme.padding};
  `};
`;

export const UpSellingCategory = Title.extend`
  font-weight: bold;
  padding: ${props => props.theme.padding};
`;

export const CheckoutButton = Button2.extend`
  font-size: 1.8rem;
  background-color: ${props => props.isLoading ? props.theme.disabledButtonBackground : props.theme.secondaryColor};
  margin-top: 0;
  &:hover {
    background-color: ${props => props.theme.button.hoverColor};
  }
  &:disabled {
    cursor: default;
    background-color: ${props => props.theme.secondaryColor};
    border-bottom: ${props => props.theme.button.primary.borderBottom};
  }
  ${media.small`
    margin-top: ${props => props.theme.margin};
  `};
`;

export const UpSellingContainer = styled.div`
  display: flex;
  margin-top: ${props => props.theme.margin};
  padding-bottom: ${props => props.theme.content.padding};
  font-size: 1.4rem;
  flex-direction: ${p => p.theme.upselling.direction};
  flex-wrap: ${p => p.theme.upselling.flexWrap};
  flex-grow: 1;
  background-color: ${p => p.theme.upselling.backgroundColor};
  overflow-y: auto;
  div div {
    width: 100%;
  }

  ${media.small`
    display: block;
    margin-top: 0;
    padding-bottom: 0;
  `};
  ${isIE11() && `
    display: block;
  `}
`;

export const UpSelling = styled.div`
  padding: ${props => props.theme.padding};
  padding-bottom: 0;
  text-align: left;
  flex-basis: 50%;
  ${media.small`
    padding-top: 0;
  `};
  ${isIE11() && `
    width: 50%;
    float: left;
  `}
`;

export const CheckoutButtonText = styled.div`
  position: relative;
  > [data-rw=price] {
    position: absolute;
    right: 0;
  }

  ${media.small`
    > [data-rw=price] {
      position: relative;
      left: 1rem;
    }
  `}
`;



// WEBPACK FOOTER //
// ./components/UpSellingModal/UpSellingModal.style.js